import { Moon, Sun, Search, Bell, LogOut, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/authStore';
import { api } from '@/lib/api';

export function Topbar() {
  const navigate = useNavigate();
  const theme = useAuth((s) => s.theme);
  const toggleTheme = useAuth((s) => s.toggleTheme);
  const user = useAuth((s) => s.usuario);
  const ente = useAuth((s) => s.enteActual);
  const clear = useAuth((s) => s.clear);

  async function logout() {
    try { await api('/auth/logout', { method: 'POST' }); } catch { /* ignore */ }
    clear();
    navigate('/login', { replace: true });
  }

  const initials = (user?.nombre ?? 'SM')
    .split(' ').filter(Boolean).slice(0, 2).map((s) => s[0]).join('').toUpperCase();

  return (
    <header className="flex h-14 items-center justify-between gap-4 border-b border-border bg-surface/80 px-5 backdrop-blur-md">
      <div className="flex max-w-md flex-1 items-center gap-2 rounded-md border border-border bg-canvas px-3 py-1.5 text-[13px] text-ink-mute transition-[border] focus-within:border-brand-500">
        <Search size={14} />
        <input
          type="search"
          placeholder="Buscar proveedor, bien, orden de compra…"
          className="h-7 w-full bg-transparent placeholder:text-ink-soft focus:outline-none"
        />
        <kbd className="hidden rounded border border-border bg-surface px-1.5 py-0.5 text-[10px] font-medium text-ink-soft md:inline-block">
          ⌘K
        </kbd>
      </div>

      <div className="flex items-center gap-1.5">
        {ente && (
          <div className="hidden items-center gap-2 rounded-md border border-border bg-canvas px-3 py-1 text-[12px] text-ink-mute md:inline-flex">
            <Building2 size={13} />
            <span className="font-medium text-ink">{ente.nombre}</span>
            <span className="num text-ink-soft">· {ente.clave}</span>
          </div>
        )}
        <button
          onClick={toggleTheme}
          className="flex h-9 w-9 items-center justify-center rounded-md text-ink-mute transition-colors hover:bg-muted hover:text-ink"
          aria-label="Alternar tema"
          title="Alternar tema"
        >
          {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
        </button>
        <button
          className="relative flex h-9 w-9 items-center justify-center rounded-md text-ink-mute transition-colors hover:bg-muted hover:text-ink"
          aria-label="Notificaciones"
          title="Notificaciones"
        >
          <Bell size={16} />
          <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-brand-500" />
        </button>
        <div className="ml-1 flex items-center gap-2 rounded-full border border-border bg-canvas py-1 pl-1 pr-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-500 text-[11px] font-semibold text-white">
            {initials}
          </div>
          <span className="hidden text-[13px] font-medium text-ink sm:inline-block">
            {user?.nombre ?? 'Invitado'}
          </span>
          <button
            onClick={logout}
            className="ml-1 flex h-7 w-7 items-center justify-center rounded-full text-ink-mute transition-colors hover:bg-muted hover:text-danger"
            aria-label="Cerrar sesión"
            title="Cerrar sesión"
          >
            <LogOut size={14} />
          </button>
        </div>
      </div>
    </header>
  );
}
